import * as React from "react";
import {
  Button,
  TextField,
  InputAdornment,
  IconButton,
  withTheme
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { isEmail } from "validator";
import { VisibilityOff, Visibility } from "@material-ui/icons";
import globalContext from "../../context/globalContext";
import label from "../../framework/whiteLabel";
import s from "./passwordLogin.module.css";

class PassLogin extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      error: false,
      labelText: "email",
      submitted: false,
      showPassword: false,
      helperText: "",
      errorText: ""
    };
  }

  handleChange = event => {
    let target = event.target;
    this.setState({
      [target.name]: target.value,
      error: false,
      labelText: "email"
    });
  };

  handleClickShowPassword = () => {
    this.setState(state => ({ showPassword: !this.state.showPassword }));
  };

  keyboardScreenAdjust = (nextInputName = null) => {
    if (nextInputName !== null) {
      if (this.state[nextInputName].length !== 0) {
        return window.scrollTo({ top: 0, behavior: "smooth" });
      } else return null;
    } else {
      return window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  render() {
    const { email, password, error, labelText, helperText } = this.state;
    const { errorSnackbarState } = this.context.global.data;

    if (errorSnackbarState) {
    }

    return (
      <div className={s.root}>
        <div className={s.rootInner}>
          <div className={s.top}>
            <img src={label.logoUrl} alt="" className={s.logo} />
            <h1 className={s.heading}>{label.title}</h1>
          </div>
          <div className={s.signUpSection}>
            <p>First time shopper?</p>
            <Link to="/register" className={s.signUpLink}>
              Sign up!
            </Link>
          </div>
          <div className={s.form}>
            <TextField
              name={"email"}
              placeholder={"email"}
              value={email}
              error={error}
              label={labelText}
              onChange={this.handleChange}
              autoCapitalize="none"
              autoCorrect="none"
              margin="normal"
              type="text"
              onBlur={() => this.keyboardScreenAdjust("password")}
            />
            <TextField
              name={"password"}
              placeholder={"password"}
              value={password}
              error={error}
              type={this.state.showPassword ? "text" : "password"}
              label={"password"}
              onChange={this.handleChange}
              autoCapitalize="none"
              autoCorrect="none"
              margin="normal"
              helperText={error ? helperText : ""}
              onBlur={() => this.keyboardScreenAdjust()}
              InputProps={{
                endAdornment: (
                  <InputAdornment
                    position="end"
                    style={{ position: "absolute", right: "0px", top: "16px" }}
                  >
                    <IconButton onClick={this.handleClickShowPassword}>
                      {this.state.showPassword ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />
          </div>
          <div className={s.bottom}>
            <Button
              onClick={() => {
                if (isEmail(email) && password.length > 0) {
                  this.context.global
                    .loginUser(email.toLowerCase(), password)
                    .then(res => {
                      if (res.status && res.status === 401) {
                        return this.globalContext.openErrorSnackbar(
                          "Wrong email or password"
                        );
                      }

                      return this.props.history.replace(`/dashboard`);
                    })
                    .catch(err => {
                      this.setState({
                        error: true,
                        errorText: "Unauthorized",
                        submitted: true
                      });
                    });
                } else {
                  this.setState({
                    error: true,
                    labelText: "Must be valid email",
                    helperText:
                      "You need to specify a valid email and password",
                    submitted: true
                  });
                }
              }}
            >
              Login
            </Button>
            <section className={s.legalSection}>
              <Link to="/reset-password" className={s.link}>
                Forgot Password
              </Link>
              <span className={s.link}>|</span>
              <Link to="/privacy-policy" className={s.link}>
                Privacy Policy
              </Link>
              <span className={s.link}>|</span>
              <Link to="/terms-of-service" className={s.link}>
                Terms of Service
              </Link>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default withTheme()(PassLogin);
